import styled from 'styled-components';

import {hiddenScroll} from 'styles';

export const Container = styled.div`
  ${hiddenScroll};
  height: 100%;
`;
